import React, { forwardRef } from 'react';
import { Box } from '@wix/design-system';
const DEFAULT_PAGE_PADDING = '0';
export const PageLayout = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    padding = DEFAULT_PAGE_PADDING,
    gap = 0,
    hidden = false
  } = _ref;
  return /*#__PURE__*/React.createElement(Box, {
    ref: ref,
    align: "center",
    direction: "vertical",
    boxSizing: "border-box",
    verticalAlign: "top",
    minHeight: "100vh",
    height: "100%",
    padding: padding,
    gap: gap,
    zIndex: 2,
    display: hidden ? 'none' : undefined
  }, children);
});
PageLayout.displayName = 'PageLayout';
//# sourceMappingURL=PageLayout.js.map